import { val } from "angular-ui-router";
import filter from 'lodash/filter';
import head from 'lodash/head';
import find from 'lodash/find';

export class PlanningResourcesService {
	constructor($resource, ApiService, $cookies, Upload) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.$cookies = $cookies;
		this._upload = Upload;

		this.planningResourcesListResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources');
		this.planningResourcesOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/PlanningResources');
		this.planningResourcesSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources/sequence');
		this.planningResourcesPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources/publish');
		this.planningResourcesDataMapplingToolListResourceUrl = this.apiService.getResourceUrl('cms/menus/DataMappingTool');
		this.planningResourcesDataMappingToolOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/DataMappingTool');
		this.planningResourcesDataMappingToolSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/DataMappingTool/sequence');
		this.planningResourcesCensusDataListResourceUrl = this.apiService.getResourceUrl('cms/menus/CensusData');
		this.planningResourcesDataMappingToolCensusDataOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/CensusData');
		this.planningResourceCensusDataUploadUrl = this.apiService.getResourceUrl('cms/census-data/upload');
		this.planningResourcesCensusDataPreviewResourceUrl = this.apiService.getResourceUrl('cms/census-data/:preview_id');
		this.planningResourcesCensusDataAddResourceUrl = this.apiService.getResourceUrl('cms/census-data');
		this.planningResourcesDataMappingToolCensusDataFiscleYearListResourceUrl = this.apiService.getResourceUrl('fiscal-year');
		this.planningResourceMobilityManagementDownloadTemplateResourceUrl = this.apiService.getResourceUrl('files/template/program-service-area');
		/**
		 * mobility Management
		 * 
		 */
		this.planningResourceMobilityManagementUploadUrl = this.apiService.getResourceUrl('cms/program-service-area/upload');
		this.planningResourcesMobilityManagementListResourceUrl = this.apiService.getResourceUrl('cms/menus/ProgramServiceAreas');
		this.planningResourcesDataMappingToolMobiltyManagmentOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/ProgramServiceAreas');
		this.planningResourcesMobilityManagementAddResourceUrl = this.apiService.getResourceUrl('cms/program-service-area');
		this.planningResourcesMobilityManagementPreviewResourceUrl = this.apiService.getResourceUrl('cms/program-service-area/:preview_id');
		/**
		 * transportation plans
		 * 
		 */
		this.planningResourcesTransportationPlansListResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationPlans');
		this.planningResourcesTransportationPlansOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationPlans');
		this.planningResourcesTransportationPlansDetailsResourceUrl = this.apiService.getResourceUrl('cms/transportation-plan/:id');
		this.planningResourcesFtaFactSheetsAndCircularsListResourceUrl = this.apiService.getResourceUrl('cms/menus/FtaFactSheetsAndCirculars');
		this.planningResourcesFtaFactSheetsAndCircularsDetailsResourceUrl = this.apiService.getResourceUrl('cms/fta-fact-sheets/:id');
		this.planningResourcesFtaFactSheetsAndCircularsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/FtaFactSheetsAndCirculars');
		this.volunteerTransportationProgramsResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/VolunteerTransportationPrograms');
		this.transportationServicesResourceUrl = this.apiService.getResourceUrl('cms/mengetGs/overview/TransportationServices');
		this.getGrantApplicationsResourceUrl = this.apiService.getResourceUrl('cms/menus/GrantApplications');
		this.grantApplicationsEditResourceUrl = this.apiService.getResourceUrl('cms/grant-applications/:content_id');
		this.getOtherReferenceMaterialsFundingResourceUrl = this.apiService.getResourceUrl('cms/menus/OtherReferenceMaterialsFunding');
		this.otherReferenceMaterialsFundingEditResourceUrl = this.apiService.getResourceUrl('cms/reference-materials-funding/:content_id');
		this.getTransportationLinksResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationLinks');
		this.getIndustryResourceUrl = this.apiService.getResourceUrl('cms/menus/Industry');
		this.transportationLinksEditResourceUrl = this.apiService.getResourceUrl('cms/transportation-links/:content_id');
		this.industryEditResourceUrl = this.apiService.getResourceUrl('cms/industry/:content_id');
		
		this.planningResourcesMobilityManagementListResource = this.$resource(this.planningResourcesMobilityManagementListResourceUrl);
		this.planningResourcesListResource = this.$resource(this.planningResourcesListResourceUrl);
		this.planningResourcesDataMapplingToolListResource = this.$resource(this.planningResourcesDataMapplingToolListResourceUrl);
		this.planningResourcesCensusDataListResource = this.$resource(this.planningResourcesCensusDataListResourceUrl);
		this.planningResourcesDataMappingToolCensusDataFiscleYearListResource = this.$resource(this.planningResourcesDataMappingToolCensusDataFiscleYearListResourceUrl);
		this.planningResourcesCensusDataPreviewResource = this.$resource(this.planningResourcesCensusDataPreviewResourceUrl);
		this.planningResourcesCensusDataAddResource = this.$resource(this.planningResourcesCensusDataAddResourceUrl);
		this.planningResourcesMobilityManagementAddResource = this.$resource(this.planningResourcesMobilityManagementAddResourceUrl);
		this.planningResourcesMobilityManagementPreviewResource = this.$resource(this.planningResourcesMobilityManagementPreviewResourceUrl);
		this.planningResourcesTransportationPlansListResource = this.$resource(this.planningResourcesTransportationPlansListResourceUrl);

		this.referenceMapEditResourceUrl = this.apiService.getResourceUrl('cms/reference-map/:content_id');
		this.referenceMapEditResource = this.$resource(this.referenceMapEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsListResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsListResourceUrl);
		this.getIndustryResource = this.$resource(this.getIndustryResourceUrl);

		this.industryEditResource = this.$resource(this.industryEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.grantApplicationsEditResource = this.$resource(this.grantApplicationsEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.otherReferenceMaterialsFundingEditResource = this.$resource(this.otherReferenceMaterialsFundingEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.transportationLinksEditResource = this.$resource(this.transportationLinksEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesOverviewResource = this.$resource(this.planningResourcesOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesSequenceResource = this.$resource(this.planningResourcesSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesPublishPageResource = this.$resource(this.planningResourcesPublishPageResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
		this.planningResourcesDataMappingToolOverviewResource = this.$resource(this.planningResourcesDataMappingToolOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesDataMappingToolSequenceResource = this.$resource(this.planningResourcesDataMappingToolSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesDataMappingToolCensusDataOverviewResource = this.$resource(this.planningResourcesDataMappingToolCensusDataOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourceMobilityManagementDownloadTemplateResource = this.$resource(this.planningResourceMobilityManagementDownloadTemplateResourceUrl);

		/**
		 * mobility Management
		 * 
		 */
		this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource = this.$resource(this.planningResourcesDataMappingToolMobiltyManagmentOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesTransportationPlansOverviewResource = this.$resource(this.planningResourcesTransportationPlansOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsOverviewResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsDetailsResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsDetailsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesTransportationPlansDetailsResource = this.$resource(this.planningResourcesTransportationPlansDetailsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.volunteerTransportationProgramsResource = this.$resource(this.volunteerTransportationProgramsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.transportationServicesResource = this.$resource(this.transportationServicesResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getGrantApplicationsResource = this.$resource(this.getGrantApplicationsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getOtherReferenceMaterialsFundingResource = this.$resource(this.getOtherReferenceMaterialsFundingResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getTransportationLinksResource = this.$resource(this.getTransportationLinksResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		
	}

	/**
	 * function for get overview
	 * @return {object} 
	 */
	_getOverviewDetails(details) {
		return {
			title: details.title,
			description: details.description,
			image: details.image
		}
	}

	/**
	 * function for set overview
	 * @return {object} 
	 */
	_setOverviewObject(details) {
		return {
			title: details.title,
			description: details.description,
			image: details.image
		}
	}

	/**
	 * function for get list planning resources
	 * @return {array} 
	 */
	_getContentDetails(content) {
		return content.map(({ title, description, name }) => ({ title, description, name }));
	}

	/**
	 * function for get sequence list
	 * @return {array} 
	 */
	_getContentSequence(value) {
		return value.map((content) => {
			return {
				id: content.menu_id,
				sortOrder: content.sort_order,
				title: content.title
			}
		});
	}

	/**
	 * function for set sequence list
	 * @return {array} 
	 */
	_setContentSequence(value) {
		return value.map((content) => {
			return {
				menu_id: content.id,
				sort_order: content.sortOrder,
				// title: content.title
			}
		});
	}

	//get publish status object for display
    _getPublishPageListObject(values) {
        return values.map(value => ({
            id: value.menu_id,
            isActive: value.is_active,
            title: value.title
        }));
    }

    //set publish status object for update
    _setPublishPageListObject(values) {
        return values.map(value => ({
            menu_id: value.id,
            is_active: value.isActive
        }));
    }

	/**
	 * function to get planning resources list
	 * @return {object} [information related to planning resources list]
	 */
	getPlanningResourcesDetails() {
		const promise = this.planningResourcesListResource.get().$promise;

		return promise.then(details => ({
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			list: this._getContentDetails(details.data.children)
		}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to get planning resources overview
	 * @return {object} [information related to planning resources overview]
	 */
	getPlanningResourcesOverview() {
		const promise = this.planningResourcesOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to edit planning resources overview
	 * @return {object} [information related to planning resources overview for edit]
	 */
	updatePlanningResourcesOverview(details) {
		const promise = this.planningResourcesOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to get planning resources sequence list
	 * @return {object} [information related to planning resources sequence list]
	 */
	getPlanningResourcesSequence() {
		const promise = this.planningResourcesSequenceResource.get().$promise;

		return promise.then((details) => this._getContentSequence(details.data));
	}

	/**
	 * function to edit planning resources sequence
	 * @return {object} [information related to planning resources sequence for edit]
	 */
	setPlanningResourcesSequence(sequenceObj) {
		const promise = this.planningResourcesSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

		return promise.then((response) => response);
	}

	//get publish status list
    getPlanningResourcesPublishPageList() {
        const promise = this.planningResourcesPublishPageResource.get().$promise;

        return promise.then(details => this._getPublishPageListObject(details.data));
    }

    //update publish status list
    setPlanningResourcesPublishPageList(list) {
        const promise = this.planningResourcesPublishPageResource.update(this._setPublishPageListObject(list)).$promise;

        return promise.then(response => response);
    }

	/**
	 * function to get planning resources Data mapping Tool list
	 * @return {object} [information related to planning resources Data mapping Tool list]
	 */
	getPlanningResourcesDataMappingToolDetails() {
		const promise = this.planningResourcesDataMapplingToolListResource.get().$promise;

		return promise.then(details => ({
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			list: this._getContentDetails(details.data.children)
		}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to get Data mapping tool overview
	 * @return {object} [information related to Data mapping tool overview]
	 */
	getDataMappingToolOverview() {
		const promise = this.planningResourcesDataMappingToolOverviewResource.get().$promise;

		return promise.then(details => {
			return this._getOverviewDetails(details.data)
		})
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to edit data Mapping tool overview
	 * @return {object} [information related to data Mapping tool overview for edit]
	 */
	updateDataMappingToolOverview(details) {
		const promise = this.planningResourcesDataMappingToolOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to get data mapping tool sequence list
	 * @return {object} [information related to planning resources sequence list]
	 */
	getDataMappingToolSequence() {
		const promise = this.planningResourcesDataMappingToolSequenceResource.get().$promise;

		return promise.then((details) => this._getContentSequence(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to edit planning resources sequence
	 * @return {object} [information related to planning resources sequence for edit]
	 */
	setDataMappingToolSequence(sequenceObj) {
		const promise = this.planningResourcesDataMappingToolSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

		return promise.then((response) => response);
	}

	/**
	 * function to get year list
	 * @return {array} [information related available years list]
	 */
	geFiscleYearList(list) {
		return list.map((value) => {
			return {
				id: value.fiscal_year_id,
				name: value.fiscal_year
			}
		})
	}

	/**
	 * function to get census data map details list
	 * @return {array} [information related census data map]
	 */
	_getMapDetail(list) {
		return list.map((value) => {
			return {
				name: value.county_name,
				ownerOccupied: value.owner_occupied ? this._getVehiclesCountObject(value.owner_occupied) : {},
				renterOccupied: value.renter_occupied ? this._getVehiclesCountObject(value.renter_occupied) : {}
			}
		})
	}

	/**
	 * function to get info related map
	 * @return {object} [information related map]
	 */

	_getVehiclesCountObject(value) {
		return {
			oneVehicle: parseInt(value['1_vehicle']),
			noVehicle: parseInt(value['no_vehicle'])
		}
	}

	/**
	 * function to get census data list
	 * @return {array} [information census data  list]
	 */
	_getCensusDataList(list) {
		return list.map((value) => ({
			uuid: value.uuid,
			fileName: value.mask_name,
			fiscleYear: value.fiscal_year,
			url: this.apiService.getResourceUrl(`files/excel/${value.uuid}`)
		}))
	}

	_getProgressDetails(list) {
		return list.map((value) => {
			return {
				id: value.content_id,
				title: value.title,
				pdf: this.apiService.getResourceUrl(`files/pdf/${value.pdf}`),
				image: this.apiService.getImageUrl(value.image)	
			}
		})
	}

	_getMobilityMapDetail(list) {
		return list.map(({ county_name, name, description }) => ({ countyName : county_name, description: description, name:name }));
	}

	_getMobiltyManagmentFileDetails(value) {
		return {
			maskName: value.mask_name,
			name: value.name,
			uuid: value.uuid,
			url: this.apiService.getResourceUrl(`files/excel/${value.uuid}`)
		}
	}

	getReportDetailsdata(details) {
		return {
			id: details.content_id,
			title: details.title,
			name: details.mask_name,
			uuid: details.pdf,
			url: this.apiService.getResourceUrl(`files/pdf/${details.pdf}`),
			image: this.apiService.getImageUrl(details.image)
		}
	}

	setReportDetailsdata(details) {
		return {
			title: details.title,
			pdf: details.uuid
		}
	}

	/**
	 * function to get map details for preview
	 * @return {object} [information map details for preview]
	 */
	getMapDeatilsById(previewId) {
		const promise = this.planningResourcesCensusDataPreviewResource.get({ preview_id: previewId }).$promise;

		return promise.then((details) => this._getMapDetail(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}


	/**
	 * function to get fiscle years
	 * @return {array} [information available fiscle years]
	 */

	getFiscleYearList() {
		const promise = this.planningResourcesDataMappingToolCensusDataFiscleYearListResource.get().$promise;

		return promise.then(details => this.geFiscleYearList(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}


	/**
	 * function to get census Data list
	 * @return {object} [information related to census Data list]
	 */
	getCensusDataDetails() {
		const promise = this.planningResourcesCensusDataListResource.get().$promise;
		return promise.then((details) => ({
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			censusDataList: this._getCensusDataList(details.data.content[0].values)

		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	/**
	 * function to get census data overview
	 * @return {object} [information related to census data overview]
	 */
	getCensusDataOverview() {
		const promise = this.planningResourcesDataMappingToolCensusDataOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to edit Census Data overview
	 * @return {object} [information related to Census data for edit]
	 */
	updateCensusDataOverview(details) {
		const promise = this.planningResourcesDataMappingToolCensusDataOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to delete rescord in Census Data
	 * @return {object} [success info]
	 */
	deleteFile(uuid) {
		const promise = this.planningResourcesCensusDataPreviewResource.delete({preview_id: uuid}).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	uploadMapFile(file) {
		const promise = this._upload.upload({
			url: this.planningResourceCensusDataUploadUrl,
			data: {
				fileObj: file,
			}
		});

		return promise.then(details => ({
				uuid: details.data.data.uuid,
				mapDetails: this._getMapDetail(details.data.data.content)
		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	addMapDetails(fiscleYearId, uuid) {
		const promise = this.planningResourcesCensusDataAddResource.save({
			uuid: uuid,
			fiscal_year_id: fiscleYearId
		}).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	downloadMobilityManagementTemplate() {
		const promise = this.planningResourceMobilityManagementDownloadTemplateResource.get().$promise;

		return promise.then(details => details)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}


	/**
	 * mobilty managment
	 */
	getMobilityManagmentetails() {
		const promise = this.planningResourcesMobilityManagementListResource.get().$promise;
		return promise.then((details) => ({
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			fileDetails: details.data.content[0].values && details.data.content[0].values.length > 0 ? this._getMobiltyManagmentFileDetails(details.data.content[0].values[0]): {}

		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getMobilityManagmentOverview() {
		const promise = this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

 	updateMobiltyManagmentOverview(details) {
		const promise = this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	uploadMobilityManagmentMapFile(file) {
		const promise = this._upload.upload({
			url: this.planningResourceMobilityManagementUploadUrl,
			data: {
				fileObj: file,
			}
		});

		return promise.then(({data: {data}}) => ({
				 uuid: data.uuid,
				 mapDetails: this._getMobilityMapDetail(data.content)
		}))

		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	addMobiltyManagementMapDetails(uuid) {
		const promise = this.planningResourcesMobilityManagementAddResource.save({
			uuid: uuid
		}).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getMobilityManagmentMapDetails(uuid) {
		const promise = this.planningResourcesMobilityManagementPreviewResource.get({preview_id: uuid}).$promise;

		return promise.then(details => ({
			mapDetails: this._getMobilityMapDetail(details.data)
		}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/**
	 * function to delete rescord in mobility managment
	 * @return {object} [success info]
	 */
	deleteProgramServiceData(uuid) {
		const promise = this.planningResourcesMobilityManagementPreviewResource.delete({preview_id: uuid}).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getCensusDataDownloadUrl() {
		let token = 'JWT=' + this.$cookies.get('token');
		return this.apiService.getResourceUrl(`files/template/census-data?${token}`);
	}

	getMobilityManagementDownloadUrl() {
		let token = 'JWT=' + this.$cookies.get('token');
		return this.apiService.getResourceUrl(`files/template/program-service-area?${token}`);
	}


	/**
	 * Transportation plans
	 */
	getTransportationPlansDetails() {
		const promise = this.planningResourcesTransportationPlansListResource.get().$promise;
		return promise.then(({data}) => ({
			overview: this._getOverviewDetails(data.menuOverviewDetails),
			list: this._getProgressDetails(head(data.content).values)

		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getTransportationPlansOverview() {
		const promise = this.planningResourcesTransportationPlansOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateTransportationPlansOverview(details) {
		const promise = this.planningResourcesTransportationPlansOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	addTransportationPlansDetails(details) {
		const promise = this.planningResourcesTransportationPlansDetailsResource.save(this.setReportDetailsdata(details)).$promise;
		return promise.then(({data}) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	updateTransportationPlansDetails(details) {
		const promise = this.planningResourcesTransportationPlansDetailsResource.update({id: details.id}, this.setReportDetailsdata(details)).$promise;
		return promise.then((data) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getTransportationPlansDetailsById(id) {
		const promise = this.planningResourcesTransportationPlansDetailsResource.get({id: id}).$promise;
		return promise.then(({data}) => this.getReportDetailsdata(data))
	}

	deleteTransportationPlansDetails(id) {
		const promise = this.planningResourcesTransportationPlansDetailsResource.delete({id: id}).$promise;
		return promise.then((data) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getFtaFactSheetsAndCircularsDetails() {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsListResource.get().$promise;
		return promise.then(({data}) => ({
			overview: this._getOverviewDetails(data.menuOverviewDetails),
			list: this._getProgressDetails(head(data.content).values)

		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});	
	}

	getFtaFactSheetsAndCircularsDetailsById(id) {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.get({id: id}).$promise;
		return promise.then(({data}) => this.getReportDetailsdata(data))
	}

	updateFtaFactSheetsAndCircularsDetails(details) {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.update({id: details.id}, this.setReportDetailsdata(details)).$promise;
		return promise.then((data) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	addFtaFactSheetsAndCircularsDetails(details) {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.save(this.setReportDetailsdata(details)).$promise;
		return promise.then(({data}) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getFtaFactSheetsAndCircularsOverview() {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsOverviewResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateFtaFactSheetsAndCircularsOverview(details) {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsOverviewResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details.data)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	deleteFtaFactSheetsAndCircularsDetails(id) {
		const promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.delete({id: id}).$promise;
		return promise.then((data) => data)
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getVolunteerTransportationProgramsDetails() {
		const promise = this.volunteerTransportationProgramsResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateVolunteerTransportationPrograms(details) {
		const promise = this.volunteerTransportationProgramsResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getTransportationServicesDetails() {
		const promise = this.transportationServicesResource.get().$promise;

		return promise.then(details => this._getOverviewDetails(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateTransportationServices(details) {
		const promise = this.transportationServicesResource.update(this._setOverviewObject(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getGrantApplicationsDetails() {
		const promise = this.getGrantApplicationsResource.get().$promise;

		return promise
			.then(details => ({
				menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
				menuContentDetails: this._getMenuContentDetails(find(details.data.content, ['name', 'GrantApplications']).values[0])
			}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updatetGrantApplications(details) {
		const promise = this.grantApplicationsEditResource.update({content_id: details.id},this._setMenuContentDetails(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getIndustryDetails() {
		const promise = this.getIndustryResource.get().$promise;

		return promise
			.then(details => ({
				menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
				menuContentDetails: this._getMenuContentDetails(find(details.data.content, ['name', 'Industry']).values[0])
			}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updatetIndustry(details) {
		const promise = this.industryEditResource.update({content_id: details.id},this._setMenuContentDetails(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getOtherReferenceMaterialsFundingDetails() {
		const promise = this.getOtherReferenceMaterialsFundingResource.get().$promise;

		return promise
			.then(details => ({
				menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
				menuContentDetails: this._getMenuContentDetails(find(details.data.content, ['name', 'OtherReferenceMaterialsFunding']).values[0])
			}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateOtherReferenceMaterialsFunding(details) {
		const promise = this.otherReferenceMaterialsFundingEditResource.update({content_id: details.id}, this._setMenuContentDetails(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getTransportationLinksDetails() {
		const promise = this.getTransportationLinksResource.get().$promise;

		return promise
			.then(details => ({
				menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
				menuContentDetails: this._getMenuContentDetails(find(details.data.content, ['name', 'TransportationLinks']).values[0])
			}))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	updateTransportationLinks(details) {
		const promise = this.transportationLinksEditResource.update({content_id: details.id},this._setMenuContentDetails(details)).$promise;

		return promise.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getReferenceMapDetailsObject({ menuOverviewDetails, content }) {
		const [data] = content;
		const { values } = data;
		const [details] = values;
		return {
			overview: this._getMenuOverviewDetails(menuOverviewDetails),
			contentId: details.content_id,
			embedCode: details.embed_code,
			description: details.description,
			images: details.images || [],
			videos: details.videos || [],
			slug: details.slug
		};
	}

	updateReferenceMapDetails({ contentId, embedCode:embed_code, description, images, videos }) {
		const promise = this.referenceMapEditResource.update({ content_id: contentId },{ embed_code, description, images, videos }).$promise;

		return promise
			.then(details => details)
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	_getMenuOverviewDetails(details) {
		return {
			id: details.content_id,
			displayName: details.display_name,
			title: details.title,
			description: details.description,
			overview: details.overview,
			image: details.image,
			name: details.name
		}
	}

	_getMenuContentDetails(value) {
		return {
			id: value.content_id,
			description: value.description,
			images: this._getContentImagesObject(value.images) || [],
			videos: value.videos || []
		}
	}

	_getContentImagesObject(values) {
		return values ? values.map(({uuid}) => ({uuid, status:-1})) : [];
	}

	_setMenuContentDetails(value) {
		return {
			description: value.description,
			images: value.images || [],
			videos: value.videos || []
		}
	}
} 


// WEBPACK FOOTER //
// ./src/app/components/planning-resources/planning-resources.service.js